import { isTesting } from 'js/src/libs/custom-utils';

export function componentsJSToRgbaString(components: number[]): string {
    return (
        'rgba(' +
        components[0] +
        ',' +
        components[1] +
        ',' +
        components[2] +
        ',' +
        components[3] +
        ')'
    );
}

export function int2rgb(hex: number): number[] {
    const rgb = [];
    rgb.push((hex >> 16) & 0xff);
    rgb.push((hex >> 8) & 0xff);
    rgb.push(hex & 0xff);

    return rgb;
}

export function int2hex(color: number): string {
    const [r, g, b] = int2rgb(color);
    const byte = (n: number) => n.toString(16).padStart(2, '0');
    return `#${byte(r)}${byte(g)}${byte(b)}`;
}

export function prefersReducedMotion() {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!mediaQuery || mediaQuery.matches) {
        return true;
    }
    return false;
}

/**
 * Whether UI transitions/animations should be turned off, either because the
 * user prefers reduced motion or because we're running in a test environment.
 * In tests, leaving MUI/Bootstrap transitions on means a closing dialog keeps
 * the rest of the app `aria-hidden` until its exit transition finishes, which
 * races accessible-name queries and causes flaky failures.
 */
export function animationsDisabled() {
    return prefersReducedMotion() || isTesting();
}
